// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZPagn","colBig":"styles_colBig__3Vhux","colSmall":"styles_colSmall__3gBwh","shopifyNameWrapper":"styles_shopifyNameWrapper__1IzbK"};